/**
 * Subscription API Service
 */
import { apiClient } from '../client';
import type {
  SubscriptionPlan,
  UserSubscription,
  UsageStats,
  CheckoutRequest,
  CheckoutResponse,
  BillingPortalResponse,
  CancelSubscriptionRequest,
  CancelSubscriptionResponse,
  PlansListResponse,
} from '../../types';

const BASE_PATH = '/api/subscription';

export const subscriptionService = {
  /**
   * Get all available subscription plans
   */
  getPlans: async (): Promise<SubscriptionPlan[]> => {
    const response = await apiClient.get<PlansListResponse>(`${BASE_PATH}/plans`);
    return response.data.plans;
  },

  /**
   * Get current user's subscription
   */
  getCurrentSubscription: async (): Promise<UserSubscription> => {
    const response = await apiClient.get<UserSubscription>(`${BASE_PATH}/current`);
    return response.data;
  },

  /**
   * Create a Stripe Checkout session for upgrading
   */
  createCheckoutSession: async (data: CheckoutRequest): Promise<CheckoutResponse> => {
    const response = await apiClient.post<CheckoutResponse>(`${BASE_PATH}/checkout`, data);
    return response.data;
  },

  /**
   * Create a Stripe Billing Portal session
   */
  createBillingPortal: async (): Promise<BillingPortalResponse> => {
    const response = await apiClient.post<BillingPortalResponse>(`${BASE_PATH}/portal`);
    return response.data;
  },

  /**
   * Cancel subscription
   */
  cancelSubscription: async (data?: CancelSubscriptionRequest): Promise<CancelSubscriptionResponse> => {
    const response = await apiClient.post<CancelSubscriptionResponse>(`${BASE_PATH}/cancel`, data || {});
    return response.data;
  },

  /**
   * Get current usage statistics
   */
  getUsageStats: async (): Promise<UsageStats> => {
    const response = await apiClient.get<UsageStats>(`${BASE_PATH}/usage`);
    return response.data;
  },

  /**
   * Restore purchases from Stripe
   */
  restorePurchases: async (): Promise<{ message: string; plan_name: string }> => {
    const response = await apiClient.post(`${BASE_PATH}/restore-purchases`);
    return response.data;
  },
};
